import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Button } from '@ubisend/pulse-components';

const FeedbackScope = ({ content }) => {
  return (
    <Button variant="inline" as={Link} to={`/feedback/${content.id}`}>
      {content.message}
    </Button>
  );
};

FeedbackScope.propTypes = {
  content: PropTypes.shape({
    id: PropTypes.number.isRequired,
    message: PropTypes.string.isRequired
  }).isRequired
};

export default FeedbackScope;
